import { Component, OnInit, ViewEncapsulation} from '@angular/core';
import { Router } from '@angular/router';
import { CompaniesService, ICompaniesSearchParams } from '@app/shared/services/companies.service';
import { Subscription } from 'rxjs';
import { SettingsService } from '../../core/settings/settings.service';

declare var $: any;

@Component({
    selector: 'app-subheader',
    templateUrl: './subheader.component.html',
    styleUrls: ['./subheader.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SubHeaderComponent implements OnInit {

    isSuperAdmin : boolean = false;
    activeCompany: any;
    sidebarEventSubscription : Subscription;

    constructor(public settings: SettingsService, private companiesService: CompaniesService, public router: Router) {
        this.isSuperAdmin = this.settings.isSuperAdmin();
    }

    ngOnInit() {
        if(this.isSuperAdmin) {
            this.sidebarEventSubscription = this.settings.sidebarChanged.subscribe(() => {
                console.log('sidebarChanged');
                this.activeCompany = this.settings.getCompany();
                if(this.activeCompany) {
                    this.companiesService.getCompany(this.settings.getCompany().code, false).subscribe(company => {
                        //refreshed company
                        this.activeCompany = {'code': company.id, 'label': company.name };
                        this.settings.setFilterFromSidebar( 'company' , this.activeCompany );
                    })
                }
            });
        } else {
            this.activeCompany = this.settings.getCompany();
        }
    }

    menuToggle() {
        console.log('prevent');
        $("app-root.layout-fixed").toggleClass("offsidebar-open");
    }

    ngOnDestroy() {
        if(this.isSuperAdmin) {
            this.sidebarEventSubscription.unsubscribe();
        }
    } 
}
